import { render, staticRenderFns } from "./baijiaDetail.vue?vue&type=template&id=b8d13e7c&scoped=true"
import script from "./baijiaDetail.vue?vue&type=script&lang=js"
export * from "./baijiaDetail.vue?vue&type=script&lang=js"
import style0 from "./baijiaDetail.vue?vue&type=style&index=0&id=b8d13e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d13e7c",
  null
  
)

export default component.exports